import React, { useState, useEffect } from 'react';
import {
	Container,
	Card,
	CardBody,
	Row,
	Col,
	Pagination,
	PaginationItem,
	PaginationLink,
	Badge,
} from 'reactstrap';
import photo from '../assets/img/instagram2.jpg';
import MenuHeader from '../components/MenuHeader';
import Header from '../components/Header';

import Footer from '../components/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { getBlogs } from '../Redux/actions/blogActions';
import { useLocation } from 'react-router-dom';
const Blogs = () => {
	const [currentPage, setCurrentPage] = useState(0);
	const [limit, setLimit] = useState(1);
	const dispatch = useDispatch();
	const { allBlogs } = useSelector(state => state.blog);
	const location = useLocation();
	const latest = location.search.split('=')[1];
	let ourArray = [];
	useEffect(() => {
		if (!allBlogs.length) {
			dispatch(getBlogs());
		}
		if (latest) {
			setCurrentPage(latest);
		}
	}, [latest]);

	return (
		<>
			<Header />
			<MenuHeader />
			<Container>
				{allBlogs &&
					allBlogs.map(ab => (
						<Card className='shadow-lg my-3'>
							<CardBody>
								<Row
									key={ab.id}
									className='d-flex align-items-center'
								>
									<Col md='4'>
										<img
											src={ab.imageURL}
											alt='photo'
											width={360}
											className='img-fluid'
										/>
									</Col>
									<Col md='8'>
										<h1>{ab.heading}</h1>
										<div>
											{ab.tags.map(tg => (
												<Badge
													className='ml-1'
													color='success'
												>
													{tg}
												</Badge>
											))}
										</div>
										<p
											dangerouslySetInnerHTML={{
												__html: ab.description,
											}}
										></p>
									</Col>
								</Row>
							</CardBody>
						</Card>
					))}
				{/* <div className='mt-5'>
					<Pagination className='d-flex justify-content-center'>
						{allBlogs && allBlogs.length > limit &&
							ourArray.fill(Math.ceil(allBlogs.length / limit)).map(
								(abs, idx) => {
									return (
										<PaginationItem>
											<PaginationLink
											// href={`?page=${idx + 1}`}
											>
												{idx + 1}
											</PaginationLink>
										</PaginationItem>
									);
								}
							)}
					</Pagination>
				</div> */}
			</Container>
			<Footer />
		</>
	);
};

export default Blogs;
